import React from 'react';
import {analyticsEmptyState} from '../../../assets/images';
import {analyticsText} from '../../../pages/Analytics/analyticsText';
import './styles.css';

interface Props {
  title?: string;
  showInfo?: boolean;
}

const AnalyticsEmptyState = React.memo(({title, showInfo = true}: Props) => {
  return (
    <div className="AnalyticsEmptyState">
      <img src={analyticsEmptyState} />
      <span className="NoData">{title || analyticsText.noData}</span>
      {showInfo && (
        <>
          <span>{analyticsText.noDataInfo1}</span>
          <span>{analyticsText.noDataInfo2}</span>
        </>
      )}
    </div>
  );
});

export default AnalyticsEmptyState;
